(() => {
  'use strict';

  const normalize = (value) => String(value || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');

  const textOfImage = (img) => normalize(`${img?.alt || ''} ${img?.currentSrc || ''} ${img?.src || ''}`);
  const isExplicitFront = (img) => /(^|\s)(front|face|avant|devant)(\s|$)/.test(textOfImage(img));
  const isBadLead = (img) => /(^|\s)(back|rear|dos|detail|details|zoom|close|closeup|macro|broderie|embroidery|manche|sleeve)(\s|$)/.test(textOfImage(img));

  const swapImageAttributes = (a, b) => {
    if (!a || !b) return;
    const attrs = ['src', 'srcset', 'sizes', 'alt', 'width', 'height'];
    const snapshot = attrs.map((name) => [name, a.getAttribute(name), b.getAttribute(name)]);
    snapshot.forEach(([name, av, bv]) => {
      if (bv === null) a.removeAttribute(name); else a.setAttribute(name, bv);
      if (av === null) b.removeAttribute(name); else b.setAttribute(name, av);
    });
  };

  const prioritizeCards = (root = document) => {
    root.querySelectorAll('[data-pk9-card]').forEach((card) => {
      const first = card.querySelector('.product-card__first');
      const second = card.querySelector('.product-card__second');
      if (!first || !second || isExplicitFront(first)) return;
      if (isExplicitFront(second) || (isBadLead(first) && !isBadLead(second))) swapImageAttributes(first, second);
    });
  };

  const visibleMedia = (gallery) => [...gallery.querySelectorAll('.product__media')]
    .filter((item) => item.style.display !== 'none' && !item.hidden);

  const prioritizeProductGallery = () => {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    const items = visibleMedia(gallery);
    if (!items.length) return;

    const explicitFront = items.find((item) => isExplicitFront(item.querySelector('img')));
    const cleanLead = items.find((item) => {
      const img = item.querySelector('img');
      return img && !isBadLead(img);
    });
    const target = explicitFront || cleanLead;
    if (!target) return;

    const first = items[0];
    if (target !== first) gallery.insertBefore(target, gallery.firstElementChild);
    requestAnimationFrame(() => gallery.scrollTo({ left: 0, behavior: 'auto' }));
  };

  const ensurePartnerPseudo = () => {
    const meta = window.PK9_PRODUCT_META;
    const form = document.querySelector('[data-product-form]');
    const panel = form?.querySelector('.product__purchase-panel');
    if (!meta || !form || !panel || panel.querySelector('.pk9-pseudo-option') || normalize(meta.type) === 'abonnement') return;

    const collections = Array.isArray(meta.collections) ? meta.collections.map(normalize) : [];
    const tags = Array.isArray(meta.tags) ? meta.tags.map(normalize) : [];
    const fingerprint = normalize(`${meta.title || ''} ${collections.join(' ')} ${tags.join(' ')}`);
    const partnerPattern = /(^|\s)(club|clubs|collab|collaboration|fpl|apc|marseille holdem|rodez|hyeres|holdem azur|ha83|pcgc|cognac|gap|althen|vidauban|dracenie|cp78|nh poker|nice hand|kill tilt)(\s|$)/;
    const isPartner = collections.some((value) => value.includes('club') || value.includes('collab'))
      || tags.some((value) => value.includes('club partenaire') || value.includes('collaboration'))
      || partnerPattern.test(fingerprint)
      || fingerprint.includes(' x pk9') || fingerprint.includes('pk9 x ');
    if (!isPartner) return;

    const block = document.createElement('div');
    block.className = 'pk9-pseudo-option pk9-pseudo-option--injected';
    block.innerHTML = '<label for="Pk9PartnerPseudo"><span>MON PSEUDO</span><small>Personnalisation optionnelle</small></label><input id="Pk9PartnerPseudo" type="text" name="properties[Mon pseudo]" maxlength="20" placeholder="Ex. RiverKing83" autocomplete="off"><p>20 caractères maximum. Laissez vide si vous ne souhaitez pas ajouter de pseudo.</p>';
    const purchase = panel.querySelector('[data-primary-purchase]');
    panel.insertBefore(block, purchase || null);
  };

  const run = (root = document) => {
    prioritizeCards(root);
    ensurePartnerPseudo();
    if (root === document || root.querySelector?.('[data-product-gallery]')) {
      setTimeout(prioritizeProductGallery, 120);
      setTimeout(prioritizeProductGallery, 360);
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-option-value]')) setTimeout(prioritizeProductGallery, 180);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(), { once: true });
  else run();
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();